import { AmplifyTypesEnum } from '../enums/amplify-types.enum';

export class StoryModel {
    id: number;
    name: string;
    type: AmplifyTypesEnum;
    createdDate: Date;
    modifiedDate: Date;
    headline?: string;
    body?: string;
    imageData?: any;
    images?: string[];
    datelineDate?: number;
    datelineLocation?: string;
}

export class ArticleSummaryViewModel {
    articleId: number;
    articleName: string;
    lastModifiedDate: Date;
}
